
export const testimonialsTranslations = {
  testimonialsTitle: {
    fr: "Ce qu'en disent nos membres",
    en: "What our members say"
  },
  testimonial1: {
    fr: "Grâce à Singularité.club, j'ai rencontré mes deux associés. C'est devenu ma première source d'opportunités qualifiées.",
    en: "Thanks to Singularité.club, I met my two associates. It has become my primary source of qualified opportunities."
  },
  testimonial2: {
    fr: "Enfin un club où on peut avancer, partager et se planter sans masque. Les contacts que j'y ai faits sont devenus des amis.",
    en: "Finally a club where we can move forward, share and fail without masks. The contacts I've made there have become friends."
  },
  testimonial3: {
    fr: "C'est le seul réseau où je peux contacter n'importe qui directement et avoir une réponse rapide et pertinente.",
    en: "It's the only network where I can contact anyone directly and get a quick and relevant response."
  },
};
